import React, { useState } from "react";
import { SlButton, SlDialog, SlTabGroup, SlTab, SlTabPanel } from "@shoelace-style/shoelace/dist/react";
import { roles } from "../../utils/constants.js";
import LineitemDateWise from "./LineitemDateWise.js"
import LineitemCreativeWise from "./LineitemCreativeWise.js";
import { Modal, Tab, Tabs, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
import LineitemCreativeDateWise from "./LineitemCreativeDateWise.js";


export const creativewiseReportsContext = React.createContext();


function LineitemReports(props) {
  const { campaign_id, setLIReportDetails, campaign_name ,status} = props;
  const [tab, setTab] = useState("dateWise");
  const [creativeDetails, setCreativeDetails] = useState(null)
  const handleTab = (type) => {
    setTab(type);
  };
  return (
    <div>
        <Modal
      show={Boolean(campaign_id)}
      onHide={() => setLIReportDetails(null)}
      backdrop="static"
      animation={false}
      dialogClassName="fullscreen-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h3>{campaign_name}</h3>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Tabs
          defaultActiveKey="dateWise"
          activeKey={tab}
          onSelect={(k) => handleTab(k)}
          id="reports-tabs"
        >
          <Tab eventKey="dateWise" title="DateWise">
            {tab === 'dateWise' && <LineitemDateWise campaign_id={campaign_id}  campaign_name={campaign_name}  status={status} />}
          </Tab>
          <Tab eventKey="creative" title="Creative Wise">
            {tab === 'creative' && <LineitemCreativeWise campaign_id={campaign_id} setCreativeDetails={setCreativeDetails}  campaign_name={campaign_name} status={status}/>}
          </Tab>
          {creativeDetails && 
            <Tab eventKey="creativedate" title={creativeDetails?.creative_name}>
            {tab === 'creativedate' && <LineitemCreativeDateWise campaign_id={campaign_id} creative_id={creativeDetails?.creative_id}  campaign_name={campaign_name} creative_name={creativeDetails?.creative_name}  status={status}/>}
          </Tab>
          }
        </Tabs>
      </Modal.Body>
    </Modal>
    </div>
  );
}

export default LineitemReports;
